import React from "react";

export function formatearPrecio(v) {
  if (v == null) return null;
  return `S/ ${Number(v).toFixed(2)}`;
}

// Muestra el ahorro real del miembro Pro/Elite: precio original tachado + final.
export function PrecioDescuento({ original, final, descuentoPct, className = "" }) {
  const tieneDescuento = descuentoPct > 0 && final < original;
  if (!tieneDescuento) {
    return (
      <span className={`text-lg font-extrabold text-slate-900 ${className}`} data-testid="precio-final">
        {formatearPrecio(original)}
      </span>
    );
  }
  return (
    <span className={`inline-flex flex-col items-start ${className}`}>
      <span className="inline-flex items-center gap-2">
        <span className="text-sm text-slate-400 line-through" data-testid="precio-original">{formatearPrecio(original)}</span>
        <span className="text-[10px] font-bold uppercase text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded">-{descuentoPct}%</span>
      </span>
      <span className="text-lg font-extrabold text-emerald-600" data-testid="precio-final">{formatearPrecio(final)}</span>
    </span>
  );
}

export default PrecioDescuento;
